import './index.css'

const importantLinks = [
    {
        title: "Pakistan Stock Exchange (PSX)",
        url: "https://www.psx.com.pk/",
        img: "/img/PSX-logo.jpg"
    },
    {
        title: "SECP",
        url: "https://www.secp.gov.pk/",
        img: "/img/secp-logo.jpg"
    },
    {
        title: "Central Depository Company",
        url: "https://www.cdcpakistan.com/",
        img: "/img/national-dipository-company-logo.jpg"
    },
    {
        title: "NCCPL",
        url: "https://www.nccpl.com.pk/",
        img: "/img/ncp-logo.jpg"
    },
    {
        title: "PSX Complaint Lodge Link",
        url: "https://www.psx.com.pk/psx/resources-and-tools/investors/investors-complaints",
        img: "/img/PSX-logo.jpg"
    },
    {
        title: "CDC Access Details",
        url: "https://www.cdcpakistan.com/about-us/cdc-access/",
        img: "/img/national-dipository-company-logo.jpg"
    },
    {
        title: "CDC Investor Account Services",
        url: "https://www.cdcpakistan.com/downloads/investor-account-closing-form/",
        img: "/img/national-dipository-company-logo.jpg"
    },
    {
        title: "CDC SMS Services Details",
        url: "https://www.cdcpakistan.com/about-us/cdc-access/sms/",
        img: "/img/national-dipository-company-logo.jpg"
    },
    {
        title: "CDC IVR Services Details",
        url: "https://www.cdcpakistan.com/about-us/cdc-access/cdc-access-ivr/",
        img: "/img/national-dipository-company-logo.jpg"
    },
    {
        title: "NCCPL UIS Service",
        url: "https://www.nccpl.com.pk/en/products-services/uin-information-system-uis",
        img: "/img/ncp-logo.jpg"
    }
];

const ImportantLinks = () => {
    return (
        <div className="important-links-container">
            <h2 className="important-title">Important Links</h2>
            <div className="links-grid">
                {importantLinks.map((link, index) => (
                    <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="link-card">
                        <img src={link.img} alt={link.title} className="link-image" />
                        <p className="link-text">{link.title}</p>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default ImportantLinks;
